import React, { useState } from "react";
import './pagina.css'

import Items from "../Items/items";

function Pagina() {
    return (
        <div className="containerPagina">
            <Items />
        </div>
    )


}

export default Pagina;